import { useMemo } from 'react';
import { useBasket } from '.';

export const useBasketProduct = (productId) => {
	const { indexedItems } = useBasket();

	const basketProduct = useMemo(() => {
		return productId && indexedItems[productId] ? indexedItems[productId] : undefined;
	}, [indexedItems, productId]);

	return basketProduct;
};
